export default __webpack_public_path__ + "static/media/step8_img2.974694f8.png";